'use strict';

// Libraries
import React from 'react';

// Services
import LANG from './lang.js';
import BadgeService from 'ck-sequencer/source/services/BadgeService';

import { getStudentProgressTableData } from 'ck-camps/source/functions/getProgressTableData.js';
import verticals from 'ck-core/source/data/verticals';

// Components
import { TabbedSelector } from 'ck-core-client/source/components/TabbedSelector';
import ProgressTable from 'ck-core-client/source/components/ProgressTable';
import BadgesTable from 'ck-core-client/source/components/BadgesTable/';
import Section from 'ck-core-client/source/components/Layout/Section';
import { TabTheme } from '../TabbedSelector/Tab/index';
import minecraftJavaIcon from 'ck-core-client/graphics/icons/icon-minecraft.svg';
import robloxStudioIcon from 'ck-core-client/graphics/icons/icon-roblox-studio.svg';
import minecraftTabBackground from 'ck-website/graphics/backgrounds/button-minecraft.svg';
import robloxTabBackground from 'ck-website/graphics/backgrounds/button-roblox.svg';

const formatTableProps = (data, vertical, props) => {
	const { activityInfo, progressPerActivity } = data[vertical];
	const tableProps = props.tableProps;
	tableProps.headings =
		tableProps.headings.length === 0 ? LANG.DEFAULT_TABLE_HEADINGS : tableProps.headings;
	return {
		title: LANG.COURSES_TABLE_TITLE,
		...tableProps,
		data: getStudentProgressTableData(activityInfo, progressPerActivity)
	};
};

const formatBadges = (data, vertical, props) => {
	const { badges } = data[vertical];
	const badgeService = new BadgeService(null, badges);
	const generatedBadgeData = badgeService.generateBadgeTableData(vertical[0] === verticals.ROBLOX);

	const rarities = [1, 2, 3].map(rarity => BadgeService.getRarityString(rarity));

	return {
		title: LANG.BADGES_TITLE,
		...props.badgesProps,
		badges: generatedBadgeData,
		rarities
	};
};

const generateContent = (data, vertical, showTables, showSection, key, props) => {
	const tableProps = showTables ? formatTableProps(data, vertical, props) : undefined;

	const badgesProps = formatBadges(data, vertical, props);
	if (showSection) {
		return (
			<React.Fragment>
				<Section key={key} borderColor="lightGrey">
					{tableProps && tableProps.data && <ProgressTable {...tableProps} />}
					{badgesProps && <BadgesTable {...badgesProps} showTooltip={true} />}
				</Section>
			</React.Fragment>
		);
	}
	return (
		<div key={key} style={{ marginTop: '3rem' }}>
			<Section borderColor="lightGrey">
				{tableProps && tableProps.data && <ProgressTable {...tableProps} />}
			</Section>
			{badgesProps && <BadgesTable {...badgesProps} showTooltip={true} />}
		</div>
	);
};

const generateTabs = (data, type, showTables, showSection, props) => {
	return [
		type === 'all' || type === 'minecraft'
			? {
					tab: {
						id: LANG.TABS.MINECRAFT.NAME,
						colour: 'green',
						title: LANG.TABS.MINECRAFT.TITLE,
						icon: minecraftJavaIcon,
						background: minecraftTabBackground
					},
					content: generateContent(data, [verticals.MINECRAFT], showTables, showSection, 1, props)
			  }
			: null,
		type === 'all' || type === 'roblox'
			? {
					tab: {
						id: LANG.TABS.ROBLOX.NAME,
						colour: 'red',
						title: LANG.TABS.ROBLOX.TITLE,
						icon: robloxStudioIcon,
						background: robloxTabBackground
					},
					content: generateContent(data, [verticals.ROBLOX], showTables, showSection, 2, props)
			  }
			: null
	].filter(tab => tab);
};

interface Props {
	data: object;
	type: string;
	showTables: boolean;
	showSection: boolean;
}

const ProgressComponent = (props: Props) => {
	const { data, type = 'all', showTables = false, showSection = false } = props;

	const output = generateTabs(data, type, showTables, showSection, props);

	return (
		<TabbedSelector
			tabs={output.map(item => item.tab)}
			contents={output.map(item => item.content)}
			theme={TabTheme.SWITCH}
		/>
	);
};

export default ProgressComponent;
